<template>
	<v-col cols="12" lg="10" xl="8">
		<v-card class="pa-2"
				rounded="lg"
				:class="{ 'px-1': $vuetify.breakpoint.smAndDown }"
				elevation="0">
			<v-card-title class="align-start flex-column">
				<a :href="portalUrl">
					<rmp-icon height="30" :color="colors.secondary.base" src="ico_logo"></rmp-icon>
				</a>
				<rmp-text type="title-medium" :color="colors.secondary.base" class="mt-8">{{ title }}</rmp-text>
			</v-card-title>
			<v-card-text>
				<slot></slot>
			</v-card-text>
		</v-card>
		<slot name="actions"></slot>
	</v-col>
</template>

<script setup lang="ts">
import RmpText from "@rmp/core/components/typography/RmpText.vue";
import RmpIcon from "@rmp/core/components/icon/RmpIcon.vue";
import { useColors } from "@rmp/core/composables/useColors";

const { colors } = useColors();

interface Props {
	title: String;
}

const props = defineProps<Props>();

const portalUrl = process.env.VUE_APP_PORTAL_BASE_URL;
</script>
